<div class="ef-page">

  <!-- ── HEADER ─────────────────────────────────────────────── -->
  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>description</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ preinvoice.uid ? 'Editar presupuesto' : 'Nuevo presupuesto' }}</h1>
      <p class="ef-header__sub">{{ preinvoice.uid ? 'Modifica los datos del presupuesto' : 'Crea un nuevo presupuesto para un cliente' }}</p>
    </div>

    <div class="ef-header__summary" *ngIf="ready && preinvoice.invoiceLines?.length > 0">
      <div class="ef-header__summary-item">
        <span class="ef-header__summary-label">Subtotal</span>
        <span class="ef-header__summary-value">{{ calcularSubtotal() }}</span>
      </div>
      <div class="ef-header__summary-divider"></div>
      <div class="ef-header__summary-item">
        <span class="ef-header__summary-label">Total</span>
        <strong class="ef-header__summary-value ef-header__summary-value--total">{{ calcularTotal() }}</strong>
      </div>
    </div>

    <ng-container *ngIf="saved">
      <mat-icon class="pf-saved-icon">done</mat-icon>
    </ng-container>

    <button mat-flat-button class="ef-btn-save" (click)="save(preinvoice)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </div>

  <!-- ── BODY ───────────────────────────────────────────────── -->
  <div class="ef-body" *ngIf="ready">
    <div class="ef-grid">

      <!-- COLUMNA IZQUIERDA -->
      <div class="ef-left">

        <!-- SECCIÓN: Receptor y fechas -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>person</mat-icon>
            <span>Receptor y fechas</span>
            <div class="ef-section__head-extra">
              <button mat-stroked-button class="ef-btn-secondary" (click)="newContact(false)">
                <mat-icon>person_add</mat-icon> Nuevo contacto
              </button>
              <span *ngIf="(newContactLoaded | async) === null" class="ef-warn-text">
                No se pudo actualizar la lista
              </span>
            </div>
          </div>
          <div class="ef-section__body">

            <!-- Receptor -->
            <app-autocomplete-select
              [items]="contactList"
              placeholder="Receptor / Cliente"
              [idField]="'companyName'"
              [(selectedItemId)]="preinvoice.receiverName"
              [displayField]="'companyName'"
              (selectionChanged)="onSelectContact($event)"
              class="w-100">
            </app-autocomplete-select>

            <!-- Centro (condicional) -->
            <ng-container *ngIf="centers.length > 0">
              <app-select name="preinvoice.centerUid" [(ngModel)]="preinvoice.centerUid" [ngModelOptions]="{standalone: true}"
                [config]="{ label: 'Centro', options: centerOptions }">
              </app-select>
            </ng-container>

            <!-- Nº presupuesto + Domicilio de entrega -->
            <div class="ef-two-col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nº Presupuesto</mat-label>
                <input matInput [(ngModel)]="preinvoice.preInvoiceNumber" name="preinvoice.preInvoiceNumber" [readonly]="true">
              </mat-form-field>
              <div class="pf-checkbox-wrap">
                <mat-checkbox [checked]="preinvoice.useDeliverAddress" (change)="toggleUseDeliverAddress($event)">
                  Usar domicilio de entrega
                </mat-checkbox>
              </div>
            </div>

            <!-- Fechas -->
            <div class="ef-two-col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha creación</mat-label>
                <input matInput [matDatepicker]="invoiceRelease" name="preinvoice.invoiceRelease"
                  [(ngModel)]="preinvoice.invoiceRelease"
                  (dateInput)="setExpiration($event)" (dateChange)="setExpiration($event)" required>
                <mat-datepicker-toggle matSuffix [for]="invoiceRelease"></mat-datepicker-toggle>
                <mat-datepicker #invoiceRelease></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha vencimiento</mat-label>
                <input matInput [matDatepicker]="invoiceExpiration" name="preinvoice.invoiceExpiration"
                  [(ngModel)]="preinvoice.invoiceExpiration" required>
                <mat-datepicker-toggle matSuffix [for]="invoiceExpiration"></mat-datepicker-toggle>
                <mat-datepicker #invoiceExpiration></mat-datepicker>
              </mat-form-field>
            </div>

          </div>
        </div>

        <!-- SECCIÓN: Cobro -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>credit_card</mat-icon>
            <span>Cobro</span>
          </div>
          <div class="ef-section__body">

            <!-- Cuenta contable de ingreso -->
            <app-autocomplete-select
              [items]="entranceList"
              placeholder="Cuenta contable de ingreso"
              [idField]="'id'"
              [isRequired]="true"
              [(selectedItemId)]="preinvoice.entranceAccount"
              [displayFields]="['number', 'name']"
              class="w-100">
            </app-autocomplete-select>

            <!-- Kilómetros (condicional) -->
            <mat-form-field *ngIf="showNumberKilometer" appearance="outline" class="w-100">
              <mat-label>Nº de kilómetros</mat-label>
              <input matInput [(ngModel)]="preinvoice.numberKilometers" name="preinvoice.numberKilometers" type="text" numberDecimalsDirective>
            </mat-form-field>

            <!-- Tipo de cobro -->
            <app-autocomplete-select
              [items]="billMethods"
              [(selectedItemId)]="preinvoice.typePay"
              [idField]="'id'"
              [isRequired]="true"
              [displayField]="'data'"
              placeholder="Tipo de cobro"
              class="w-100">
            </app-autocomplete-select>

            <!-- Socio -->
            <ng-container *ngIf="preinvoice.typePay === 'Socio'">
              <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="preinvoice.partnersId"
                [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socio" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <!-- Efectivo -->
            <ng-container *ngIf="preinvoice.typePay === 'Efectivo'">
              <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="preinvoice.efectivoId"
                [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja/Efectivo" class="w-100">
              </app-autocomplete-select>
            </ng-container>

            <!-- Cuentas bancarias -->
            <ng-container *ngIf="preinvoice.typePay === 'Transferencia bancaria'
              || preinvoice.typePay === 'Remesa en cuenta'
              || preinvoice.typePay === 'Tarjeta'
              || preinvoice.typePay === 'Confirming'
              || preinvoice.typePay === 'Pagarés'">
              <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="preinvoice.typePayBankAccount"
                [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuenta bancaria" class="w-100">
              </app-autocomplete-select>
            </ng-container>

          </div>
        </div>

        <!-- SECCIÓN: Conceptos -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>receipt</mat-icon>
            <span>Conceptos</span>
          </div>
          <div class="ef-section__body">

            <!-- Líneas -->
            <div *ngFor="let item of preinvoice.invoiceLines; index as i; trackBy: trackByIndex" class="ef-line-wrap">
              <div class="pf-line-header">
                <span class="pf-line-product">{{ item.product || 'Concepto sin nombre' }}</span>
                <strong class="pf-line-total">{{ calcularTotalesLinea(item) }} €</strong>
              </div>
              <div class="pf-line-details">
                <span class="pf-chip">{{ item.quantity }} ud.</span>
                <span class="pf-chip">{{ item.unityAmount }} €/ud.</span>
                <span class="pf-chip" *ngIf="item.discount">dto. {{ item.discount }}%</span>
                <span class="pf-chip pf-chip--tax" *ngIf="getStrTaxes(item.taxes)">{{ getStrTaxes(item.taxes) }}</span>
              </div>
              <div class="pf-line-footer">
                <button mat-stroked-button class="pf-btn-edit" type="button" (click)="toggleEditMode(i)">
                  <mat-icon>edit</mat-icon> Editar
                </button>
                <button mat-stroked-button class="ef-btn-remove-line" type="button" (click)="removeInvoiceLine(item)">
                  <mat-icon>delete</mat-icon> Eliminar
                </button>
              </div>
            </div>

            <div class="ef-line-actions">
              <button mat-stroked-button class="ef-btn-add-line" type="button" (click)="addInvoiceLine()">
                <mat-icon>add</mat-icon> Añadir concepto
              </button>
            </div>

            <!-- Totales -->
            <div class="ef-totals" *ngIf="preinvoice.invoiceLines?.length > 0">
              <div class="ef-totals__row">
                <span class="ef-totals__label">Subtotal</span>
                <span class="ef-totals__value">{{ calcularSubtotal() }}</span>
              </div>
              <div *ngFor="let taxView of impuestos(); trackBy: trackByIndex" class="ef-totals__row">
                <span class="ef-totals__label">{{ taxView }}</span>
              </div>
              <div class="ef-totals__row ef-totals__row--final">
                <span class="ef-totals__label">Total</span>
                <strong class="ef-totals__value ef-totals__value--total">{{ calcularTotal() }}</strong>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- COLUMNA DERECHA -->
      <div class="ef-right">

        <!-- Proyecto (condicional) -->
        <div class="ef-section" *ngIf="isProjectEnable && projects?.length > 0">
          <div class="ef-section__head">
            <mat-icon>folder</mat-icon>
            <span>Proyecto</span>
          </div>
          <div class="ef-section__body">
            <app-autocomplete-select [items]="projects" [(selectedItemId)]="preinvoice.projectUid"
              [idField]="'id'" [displayField]="'display'" placeholder="Proyecto" class="w-100">
            </app-autocomplete-select>
          </div>
        </div>

        <!-- Comentarios -->
        <div class="ef-section">
          <div class="ef-section__head">
            <mat-icon>description</mat-icon>
            <span>Comentarios</span>
          </div>
          <div class="ef-section__body">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Comentarios / Información adicional</mat-label>
              <textarea matInput [(ngModel)]="preinvoice.comments" name="preinvoice.comments" rows="6"></textarea>
            </mat-form-field>
          </div>
        </div>

      </div>

    </div>
  </div>

  <!-- Loading -->
  <div class="ef-loading" *ngIf="!ready">
    <div class="ef-loading__icon"><mat-icon>description</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="ef-loading__text">Cargando formulario…</p>
  </div>

</div>
